import { StarIcon } from "@heroicons/react/24/solid";
import type { StackProps } from "@highoutput/ui-components";
import { chakra, Flex, HStack, Icon } from "@highoutput/ui-components";
import For from "../../../utilities/for";

type IconConfig = {
  size?: {
    width?: string | number;
    height?: string | number;
  };
};

export type RatingProps = (
  | { readonly?: false; onChange?: (newValue: number) => void }
  | { readonly: true }
) & {
  value?: number;
  config?: {
    icon?: IconConfig;
  };
};

export default function Rating(props: RatingProps & Omit<StackProps, "onChange">) {
  const { value, onChange, readonly, config, ...others } = Object.assign(defaultProps, props);

  return (
    <HStack {...others}>
      <For each={[1, 2, 3, 4, 5]}>
        {(number) => {
          const Star = () => {
            const active = Math.round(value) >= number;
            const color = active ? "#F9D209" : "rgba(240,237,236,0.4)";

            return (
              <Icon
                as={StarIcon}
                fill={color}
                width={config.icon.size.height}
                height={config.icon.size.width}
                data-active={active}
              />
            );
          };

          if (readonly)
            return (
              <Flex>
                <Star />
              </Flex>
            );

          return (
            <chakra.button
              role="button"
              aria-label={`Rate ${number}`}
              display="flex"
              onClick={() => onChange(number)}
            >
              <Star />
            </chakra.button>
          );
        }}
      </For>
    </HStack>
  );
}

const defaultProps = {
  value: 0,
  onChange() {
    return;
  },
  config: {
    icon: {
      size: {
        width: "20px",
        height: "20px",
      },
    },
  },
};
